import type { LinkProps } from '@remix-run/react'
import { Link as RmxLink, useLocation } from '@remix-run/react'
import { forwardRef } from 'react'

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ state, children, ...rest }, ref) => {
	const location = useLocation()

	return (
		<RmxLink ref={ref} {...rest} state={{ ...state, prevPath: `${location.pathname}${location.search}` }}>
			{children}
		</RmxLink>
	)
})

Link.displayName = 'Link'
